
// 智慧大脑
import InterfaceConfig from '../view/IntellectualBrain/InterfaceConfig/InterfaceConfig'
import InterfaceManage from '../view/IntellectualBrain/InterfaceManage/InterfaceManage'
import InterfaceAdd from '../view/IntellectualBrain/InterfaceManage/InterfaceAdd'
import InterfaceModify from '../view/IntellectualBrain/InterfaceManage/InterfaceModify'
import IntellectualBrainNav from '../view/IntellectualBrain/IntellectualBrainNav'

export default [
    {
        path: '/interface_config',
        name: 'interface-config',
        components: {
            default: IntellectualBrainNav,
            a: InterfaceConfig
        }
    },
    {
        path: '/interface_manage',
        name: 'interface-manage',
        components: {
            default: IntellectualBrainNav,
            a: InterfaceManage
        }
    },
    {
        path: '/interface_add',
        name: 'interface-add',
        components: {
            default: IntellectualBrainNav,
            a: InterfaceAdd
        }
    },
    {
        path: '/interface_modify/:id',
        name: 'interface-modify',
        components: {
            default: IntellectualBrainNav,
            a: InterfaceModify
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/IntellectualBrain.js